import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {ResponsiveModal} from "@pg-design/modal-module";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

interface IProps {
    vendorName: string | null;
    isClauseVisible: boolean;
    ctaText: string;
    isSending: boolean;
    isConfirmDisabled: boolean;
    onConfirm: () => void;
}

export const UnlockChoiceModalFooter = (props: IProps) => {
    const {vendorName, isClauseVisible, ctaText, isSending, isConfirmDisabled, onConfirm} = props;

    const vendorLabel = vendorName ? `dewelopera ${vendorName}` : "dewelopera";

    return (
        <ResponsiveModal.Footer className={footerStyle}>
            <div className={isClauseVisible ? clauseRevealStyle : hiddenClauseRevealStyle} aria-hidden={!isClauseVisible}>
                <div className={clauseClipStyle}>
                    <Text as="p" variant="info_txt_1" color="var(--colors-gray-700)" className={clauseStyle}>
                        Wraz ze zgłoszeniem prześlemy Twoje dane kontaktowe do {vendorLabel}, który porozmawia z Tobą bez zobowiązań.
                    </Text>
                </div>
            </div>

            <div className={ctaStyle}>
                <Button
                    type="button"
                    variant="filled_primary"
                    size="medium"
                    fullWidth
                    className={ctaButtonStyle}
                    isLoading={isSending}
                    disabled={isConfirmDisabled || isSending}
                    onClick={onConfirm}
                    dataTestId={OFFER_TEST_IDS.LEAD_FORM.UNLOCK_CHOICE_CONFIRM_BUTTON}
                >
                    {ctaText}
                </Button>

                <Text as="p" variant="info_txt_1" color="var(--colors-gray-700)" align="center" className={legalStyle}>
                    Administratorem danych osobowych jest <br />
                    Property Group sp. z o.o.{" "}
                    <a href={rpAppLink.termsOfService.base()} target="_blank" rel="noopener" className={termsLinkStyle}>
                        Regulamin
                    </a>
                    .
                </Text>
            </div>
        </ResponsiveModal.Footer>
    );
};

const footerStyle = css({
    px: 2,
    pt: 1.5,
    pb: 3,
    md: {
        px: 3,
        pt: 0
    }
});

const clauseRevealBaseStyle = css.raw({
    display: "grid",
    transitionProperty: "grid-template-rows, opacity, visibility",
    transitionDuration: "250ms",
    transitionTimingFunction: "ease-out",
    _motionReduce: {
        transitionDuration: "0ms"
    }
});

const clauseRevealStyle = css({
    ...clauseRevealBaseStyle,
    gridTemplateRows: "1fr",
    opacity: 1,
    visibility: "visible"
});

const hiddenClauseRevealStyle = css({
    ...clauseRevealBaseStyle,
    gridTemplateRows: "0fr",
    opacity: 0,
    visibility: "hidden"
});

const clauseClipStyle = css({
    minHeight: 0,
    overflow: "hidden"
});

const clauseStyle = css({
    fontSize: "1.067rem",
    lineHeight: "1.2rem",
    pb: 3,
    md: {
        pb: 2
    }
});

const ctaStyle = css({
    display: "flex",
    flexDirection: "column",
    rowGap: 1,
    md: {
        pt: 1
    }
});

const ctaButtonStyle = css({
    height: "auto",
    minHeight: "5.6rem",
    py: 1,
    whiteSpace: "normal",
    textAlign: "center"
});

const legalStyle = css({
    fontSize: "1.067rem",
    lineHeight: "1.2rem"
});

const termsLinkStyle = css({
    color: "var(--colors-secondary)",
    textDecoration: "underline",
    _focusVisible: {
        outline: "2px solid var(--colors-secondary)",
        outlineOffset: "2px"
    }
});
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {ResponsiveModal} from "@pg-design/modal-module";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

interface IProps {
    vendorName: string | null;
    isClauseVisible: boolean;
    ctaText: string;
    isSending: boolean;
    isConfirmDisabled: boolean;
    onConfirm: () => void;
}

export const UnlockChoiceModalFooter = (props: IProps) => {
    const {vendorName, isClauseVisible, ctaText, isSending, isConfirmDisabled, onConfirm} = props;

    const vendorLabel = vendorName ? `dewelopera ${vendorName}` : "dewelopera";

    return (
        <ResponsiveModal.Footer className={footerStyle}>
            <div className={isClauseVisible ? clauseRevealStyle : hiddenClauseRevealStyle} aria-hidden={!isClauseVisible}>
                <div className={clauseClipStyle}>
                    <Text as="p" variant="info_txt_1" color="var(--colors-gray-700)" className={clauseStyle}>
                        Wraz ze zgłoszeniem prześlemy Twoje dane kontaktowe do {vendorLabel}, który porozmawia z Tobą bez zobowiązań.
                    </Text>
                </div>
            </div>

            <div className={ctaStyle}>
                <Button
                    type="button"
                    variant="filled_primary"
                    size="medium"
                    fullWidth
                    className={ctaButtonStyle}
                    isLoading={isSending}
                    disabled={isConfirmDisabled || isSending}
                    onClick={onConfirm}
                    dataTestId={OFFER_TEST_IDS.LEAD_FORM.UNLOCK_CHOICE_CONFIRM_BUTTON}
                >
                    {ctaText}
                </Button>

                <Text as="p" variant="info_txt_1" color="var(--colors-gray-700)" align="center" className={legalStyle}>
                    Administratorem danych osobowych jest <br />
                    Property Group sp. z o.o.{" "}
                    <a href={rpAppLink.termsOfService.base()} target="_blank" rel="noopener" className={termsLinkStyle}>
                        Regulamin
                    </a>
                    .
                </Text>
            </div>
        </ResponsiveModal.Footer>
    );
};

const footerStyle = css({
    px: 2,
    pt: 1.5,
    pb: 3,
    md: {
        px: 3,
        pt: 0
    }
});

const clauseRevealBaseStyle = css.raw({
    display: "grid",
    transitionProperty: "grid-template-rows, opacity, visibility",
    transitionDuration: "250ms",
    transitionTimingFunction: "ease-out",
    _motionReduce: {
        transitionDuration: "0ms"
    }
});

const clauseRevealStyle = css({
    ...clauseRevealBaseStyle,
    gridTemplateRows: "1fr",
    opacity: 1,
    visibility: "visible"
});

const hiddenClauseRevealStyle = css({
    ...clauseRevealBaseStyle,
    gridTemplateRows: "0fr",
    opacity: 0,
    visibility: "hidden"
});

const clauseClipStyle = css({
    minHeight: 0,
    overflow: "hidden"
});

const clauseStyle = css({
    fontSize: "1.067rem",
    lineHeight: "1.2rem",
    pb: 3,
    md: {
        pb: 2
    }
});

const ctaStyle = css({
    display: "flex",
    flexDirection: "column",
    rowGap: 1,
    md: {
        pt: 1
    }
});

const ctaButtonStyle = css({
    height: "auto",
    minHeight: "5.6rem",
    py: 1,
    whiteSpace: "normal",
    textAlign: "center"
});

const legalStyle = css({
    fontSize: "1.067rem",
    lineHeight: "1.2rem"
});

const termsLinkStyle = css({
    color: "var(--colors-secondary)",
    textDecoration: "underline",
    _focusVisible: {
        outline: "2px solid var(--colors-secondary)",
        outlineOffset: "2px"
    }
});
